import type React from 'react';

import { CTASection } from './components/CTASection';
import { PetitionSteps } from './components/PetitionSteps';
import { RelatedArticles } from './components/RelatedArticles';

export const PageBody: React.FC = () => {
	return (
		<div className="mt-16">
			<div className="bg-background-raised py-10">
				<div className="container space-y-16">
					<PetitionSteps />
					<CTASection />
				</div>
			</div>
			<div className="container mt-16">
				<RelatedArticles />
			</div>
		</div>
	);
};
